export function getObjectEntries<T extends object>(obj: T): { [K in keyof T]: [K, T[K]] }[keyof T][] {
    return Object.entries(obj) as { [K in keyof T]: [K, T[K]] }[keyof T][];
}
